import {t} from '@github-ui/swp-core/lib/utils/localization'
import type {PrimerComponentCtaBanner} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentCtaBanner'
import {documentToPlainTextString} from '@contentful/rich-text-plain-text-renderer'

import type {FeaturesTableProps} from '../components/generic/FeaturesTable/FeaturesTable.types'
import type {GenericSection, PricingTable} from '../../../../brand/lib/types/contentful'

// Components --
const sanitizePricingTableData = (pricingTableComponents: PricingTable[]) => {
  const pricingTableData: FeaturesTableProps[] = pricingTableComponents
    .map(item => ({
      id: item.sys.id,
      ...item.fields,
    }))
    .map(item => ({
      ...item,
      title: item.title || '',
      aria: {included: t('Included'), notIncluded: t('Not included')},
      columns: item.columns
        .map(column => ({
          id: column.sys.id,
          ...column.fields,
        }))
        .map(column => ({
          title: column.title,
          price: column.price,
          currency: column.currency,
          ctaPrimary: column.ctaPrimary?.fields,
          ctaSecondary: column.ctaSecondary?.fields,
        })),
      rows: item.rows
        .map(row => ({
          id: row.sys.id,
          ...row.fields,
        }))
        .map(row => ({
          ...row,
          description: row.description ? documentToPlainTextString(row.description) : '',
          content: row.content.map(cell => ({
            availability: cell.fields.availability,
            customText: cell.fields.customText ? documentToPlainTextString(cell.fields.customText) : '',
          })),
        })),
    }))

  return pricingTableData
}

// Sections ---
export const sanitizePricingSectionData = (pricingSectionData: GenericSection) => {
  const fields = pricingSectionData?.fields
  if (!fields?.content) {
    return null
  }

  const pricingTableComponents = fields.content.filter(
    item => item.sys.contentType.sys.id === 'pricingTable',
  ) as PricingTable[]
  const pricingTable = sanitizePricingTableData(pricingTableComponents)

  const ctaBannerComponent = fields.content?.find(
    item => item.sys.contentType.sys.id === 'primerComponentCtaBanner',
  ) as PrimerComponentCtaBanner

  return {pricingTable, ctaBanner: ctaBannerComponent}
}
